
import startApp from "../../entry";
import archivesPage from "./archives.vue";

startApp(archivesPage);
